export default {
  api: {
    href: 'https://api.binsentry.com',
  },
};
